const Admin = () => import(/* webpackChunkName: "proj" */ './Admin');
const Appl = () => import(/* webpackChunkName: "proj" */ './Appl');

export default {
  routes: [
    {
      path: '/proc/patn2019/admin',
      name: 'proc_patn2019_admin',
      component: Admin,
      meta:{public:true}
    },
    {
      path: '/proc/patn2019/appl',
      name: 'proc_patn2019_appl',
      component: Appl,
      meta:{public:true}
    }
  ]
}



// WEBPACK FOOTER //
// ./src/components/proc/patn2019/router.js